// extracted by mini-css-extract-plugin
export default {"volunteerContainer":"Notices_volunteerContainer__+V2lX","volunteerWrapper":"Notices_volunteerWrapper__L9aT2"};